/* Этот файл сгенерирован автоматически на основe шаблона exportService.hbs */
/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SyncResponse } from '../models';
import { request } from 'api/apiRouter';
import type { ApiRequestOptions, ApiResponse } from '@web-chat-core/toolkit/src/api3';
export class SyncUnAuthorizedControllerService {
    public static sync(options?: ApiRequestOptions): Promise<ApiResponse<SyncResponse>> {
        return request('meet', {
            ...options,
            method: 'GET',
            url: '/api/v1/sync-unauthorized',
            errors: {
                401: `UNAUTHORIZED: accessToken is not valid.`,
                403: `Forbidden`,
            },
        });
    }
}
